import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/automation/campaign-logs.css";
// import BackAddBtns from "../../components/Open-pages/target-matrics/common/BackAddBtns";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import { selectAuth } from "../../components/auth/auth.selector";
import { fetchAllCampaignsData } from "../../redux/reducers/apiSlice";
import CampaignForm from "../../components/automation/campaign/CampaignForm";
import CampaignLogs from "../../components/automation/campaign/CampaignLogs";
// import MealsStructure from "../../components/diet/meal/MealsStructure";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";

const CampaignSystem = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { allCampaigns, loading, error } = useSelector((state) => state.api);

  const iniModValues = {
    isModOpen: false,
  };
  const [modValues, setModValues] = useState(iniModValues);

  const [isPage, setIsPage] = useState(0);
  const iniFilters = {
    page: isPage + 1,
    limit: 10,
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniTbDatas = {
    allData: [],
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onClickModal = () => {
    setModValues((prevs) => ({ ...prevs, isModOpen: true }));
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    dispatch(
      fetchAllCampaignsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }, [filters]);

  useEffect(() => {
    if (allCampaigns?.status && !error && !loading) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: allCampaigns?.data || [],
        pagination: allCampaigns?.pagination || [],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: [],
        pagination: [],
      }));
    }
  }, [allCampaigns, error, loading]);

  return (
    <HelmetWrapper title="WTF: Campaign Management System">
      <Container
        className="bg-cloud-k px-50px daily-target-metrics-container r-mt30"
        fluid
      >
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={closeModal}
          contentLabel="Add Modal"
          ariaHideApp={false}
        >
          <div className="createNewCTOModalContainer mod-width-70p mod-height-95vh">
            <ModalHeadAndClose title="Add Campaign" onClose={closeModal} />

            <CampaignForm
              userInfoData={userInfoData}
              closeModal={closeModal}
              callFunction={() =>
                dispatch(
                  fetchAllCampaignsData({
                    filters: filters,
                    token: userInfoData?.token,
                  })
                )
              }
            />
          </div>
        </Modal>

        {/* <Row>
          <Col>
            <MealsStructure text={"Campaign System"} />
          </Col>
        </Row> */}

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Campaign System"}
              createBtnTxt={"Add New Campaign"}
              onClickCreateBtn={onClickModal}
              isReload={() =>
                dispatch(
                  fetchAllCampaignsData({
                    filters: filters,
                    token: userInfoData?.token,
                  })
                )
              }
            />

            {/* <BackAddBtns
              addBtnTxt={"Add New Campaign"}
              onClickAdd={onClickModal}
              onClickReload={() =>
                dispatch(
                  fetchAllCampaignsData({
                    filters: filters,
                    token: userInfoData?.token,
                  })
                )
              }
              isAddBtn={true}
            /> */}
          </Col>
        </Row>

        <Row>
          <Col>
            <CampaignLogs
              userInfoData={userInfoData}
              isLoading={loading}
              tbDatas={tbDatas}
              isPage={isPage}
              setIsPage={setIsPage}
              callFunction={() =>
                dispatch(
                  fetchAllCampaignsData({
                    filters: filters,
                    token: userInfoData?.token,
                  })
                )
              }
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default CampaignSystem;
